export const FirebaseConfig = {
	"projectId": "ecsexpress",
	"appId": "1:590297003075:web:4227bcd33e4237988650f6",
	"databaseURL": "https://ecsexpress-default-rtdb.firebaseio.com",
	"storageBucket": "ecsexpress.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyDsggR9rpIA2QNWsAn8OWEo9Jy3-iiauA0",
	"authDomain": "ecsexpress.firebaseapp.com",
	"messagingSenderId": "590297003075",
	"measurementId": "G-JF7Q988PCG",
	"projectNumber": "590297003075",
	"version": "2"
};